import { render } from "./HomeHeaderDescription.vue?vue&type=template&id=492e4e5a"
import script from "./HomeHeaderDescription.vue?vue&type=script&lang=ts"
export * from "./HomeHeaderDescription.vue?vue&type=script&lang=ts"

import "./HomeHeaderDescription.vue?vue&type=style&index=0&id=492e4e5a&lang=postcss"
script.render = render

export default script